"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _MenuItemIcon = _interopRequireDefault(require("./MenuItemIcon"));
var _Context = require("../../Context");
var _constants = require("../../../constants");
var _Tooltip = _interopRequireDefault(require("../../../../components/Tooltip"));
var _menu = require("../../../utils/menu");
var _ExpandableMenuItemTitleClamp = _interopRequireDefault(require("./ExpandableMenuItemTitleClamp"));
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const MenuItem = exports.MenuItem = (0, _react.memo)(({
  level,
  isActive,
  hasInnerNode,
  link,
  linkMeta,
  iconUri,
  title,
  isExpanded,
  onArrowIndicatorClick,
  history,
  theme,
  isOpen,
  isExpandable,
  isClosable,
  isPartOfActivePath
}) => {
  const config = (0, _react.useContext)(_Context.ConfigContext);
  const withinSameModule = (0, _menu.isWithinSameModule)(link, config.appPrefix) && history;
  const handleArrowIndicatorClick = event => {
    event.preventDefault();
    event.stopPropagation();
    onArrowIndicatorClick();
  };
  const handleNavigate = () => {
    const nextPath = (0, _menu.getPathFromLink)(link, config.appPrefix);
    history.push(nextPath);
  };
  const isCollapsed = !isExpanded;
  const expandableMenuItem = level > 3 ? _react.default.createElement(_Tooltip.default, {
    title: title,
    collapsed: isCollapsed,
    isOpen: isOpen,
    tooltip: title,
    target: _ExpandableMenuItemTitleClamp.default,
    tooltipPosition: "right"
  }) : _react.default.createElement(_styles.MenuItemTitleDiv, {
    title: title,
    $collapsed: isCollapsed,
    isOpen: isOpen
  }, title);
  return _react.default.createElement(_styles.MenuItemContainer, {
    active: isActive,
    hasArrowIndicator: hasInnerNode,
    href: withinSameModule ? null : link,
    onClick: withinSameModule ? handleNavigate : null,
    target: linkMeta && linkMeta.newTab ? '_blank' : '_self',
    "data-test-title": title,
    $collapsed: isCollapsed,
    submenuItem: level > 2,
    isExpandable: isExpandable,
    isPartOfActivePath: isPartOfActivePath,
    level: level
  }, !(isExpanded && theme.name === _constants.THEMES.mds) && level < 3 && _react.default.createElement(_Tooltip.default, {
    path: iconUri && iconUri.startsWith('/') ? `${window.location.origin}${iconUri}` : `${window.location.origin}/${iconUri}`,
    label: title,
    displayTooltip: !isExpanded,
    target: _MenuItemIcon.default,
    tooltip: title,
    tooltipDelay: 500,
    tooltipPosition: "right"
  }), isExpandable ? expandableMenuItem : _react.default.createElement(_styles.MenuItemTitleClamp, {
    text: title,
    title: title,
    $collapsed: isCollapsed
  }), hasInnerNode && _react.default.createElement(_styles.MenuItemArrowClickArea, {
    onClick: handleArrowIndicatorClick
  }, _react.default.createElement(_styles.MenuItemArrowClickAreaInner, null, _react.default.createElement(_styles.MenuItemArrowIndicator, {
    $expandable: isExpandable,
    $open: isOpen,
    $closable: isClosable
  }))));
});
MenuItem.defaultPropTypes = {
  isActive: false,
  isExpanded: true,
  isClosable: true,
  isOpen: false,
  isExpandable: false,
  isPartOfActivePath: false,
  iconUri: '',
  hasInnerNode: false,
  onArrowIndicatorClick: () => {},
  theme: {}
};
var _default = exports.default = (0, _styledComponents.withTheme)(MenuItem);